<template>
    <section class="g-container || o-band">
        <div class="o-container">

            <app-intro class="u-d-flex align-items-center justify-content-between">
                <h3 class="u-mb-0">Abonnementen</h3>
            </app-intro>

            <loading v-bind:nodes="subscriptions">Bezig met laden van de abonnementen...</loading>

            <transition-group class="g-cols:2>sm g-cols:3>md g-cols:2>lg g-cols:3>xl || g-gap:1-xs g-gap:1-sm>sm" name="fade" tag="section" v-if="locations.length">
                <router-link :to="`/admin/subscriptions/${sub.ProductID}/update`" class="c-node" v-for="sub in subscriptions" :key="'location-' + sub.ProductID">
                    <h4 class="c-node__title">{{ sub.Productnaam }}</h4>
                    <span v-if="sub.Aantal >= 1">{{ sub.Omschrijving }}</span>
                    <span v-if="sub.Aantal === 0" class="u-text-danger">{{ sub.Omschrijving }}</span>
                </router-link>
            </transition-group>

            <div v-else>
                <p>Er zijn nog geen vestigingen aangemaakt. Maak er <router-link to="/admin/locations/add">hier</router-link> een aan.</p>
            </div>

        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import AppIntro from '../../components/app/AppIntro.vue';
    import Loading from '../../components/Loading.vue';

    export default {
        components: { AppIntro, Loading },
        data () {
            return {
                sorting: false,
                order: {
                    name: false,
                    style: false,
                    status: false,
                    price: false,
                    date: 'desc',
                },
            };
        },
        computed: {
            ...mapState({
                subscriptions: (state) => state.subscription.list,
                locations: (state) => state.location.list,
            }),
        },
        created () {
            this.$store.dispatch('location/list');
            this.$store.dispatch('subscription/list');
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    /*.table {
        @include media-breakpoint-only(sm) {
            grid-template-columns: rem(150) 1fr;
            margin: 0;
            max-width: 100%;
        }
    }*/
</style>
